import { MF_ACCESS_REVIEWS } from "./accessReviews";
import { MF_CATALOGS } from "./catalog";
import { members } from "./member";
import { MF_OFFBOARDING } from "./offboarding";
import { MF_OPTIONS } from "./options";

const MFMembers = {
  ...members,
  ...MF_ACCESS_REVIEWS,
  ...MF_CATALOGS,
  ...MF_OFFBOARDING,
  ...MF_OPTIONS,
};

export default MFMembers;
